export { formatBRL, formatPhone, maskPhone } from '@sc/shared/domain';

/** "2.4567" -> "2,46%" */
export function formatRate(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  return Number.isFinite(n)
    ? `${n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`
    : '—';
}

export function relativeTime(date: string | Date, now = Date.now()): string {
  const diff = Math.max(0, now - new Date(date).getTime());
  const min = Math.round(diff / 60_000);
  if (min < 1) return 'agora';
  if (min < 60) return `há ${min} min`;
  const h = Math.round(min / 60);
  if (h < 24) return `há ${h} h`;
  const d = Math.round(h / 24);
  if (d === 1) return 'ontem';
  return `há ${d} dias`;
}

export function formatDateTime(date: string | Date): string {
  return new Date(date).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatTime(date: string | Date): string {
  return new Date(date).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

/** Micro-dólares -> "US$ 0,12" */
export function formatUsdMicro(micro: number): string {
  const usd = micro / 1_000_000;
  // Conversas custam frações de centavo: mostra 4 casas abaixo de US$ 0,01.
  const digits = usd > 0 && usd < 0.01 ? 4 : 2;
  return usd.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function formatInt(n: number): string {
  return n.toLocaleString('pt-BR');
}
